import "./DatiPersonaliRiconosciutoPage.css";
import { t } from "../../../services/formatters";
import { Button } from "../../../components/Button";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { useDatiPersonaliRiconosciutoPage } from "./useDatiPersonaliRiconosciutoPage";
import { ErrorModal } from "../../../components/ErrorModal";
import { FormDatiUtenteRiconosciuto } from "../../../components/FormDatiUtenteRiconosciuto";
import { useEffect } from "react";
import { InformativeC5 } from "../../../components/InformativeC5";
import { Riepilogo } from "../../../components/Riepilogo";

export const DatiPersonaliRiconosciutoC5Page = () => {
    const { next, edit, read, isCreaAppuntamentoBusy, fetchErrorMessage, fetchError, setFetchError } = useDatiPersonaliRiconosciutoPage();

    useEffect(() => {
        window.dataLayer.push({
            event: "customPageview",
            virtualPageURL: "/fa3/c5/fissa-appuntamento/dati-personali-riconosciuto",
            funnelVersion: "nuovo",
            FA_funnel: "Cessione del quinto",
            crmIdentification: "utente riconosciuto",
            capFiliale: read("cap"),
        });
    }, []);

    return (
        <div id="dati-personali-riconosciuto-page">
            <Breadcrumb />

            {/* riepilogo */}
            {read("id_filiale_direct_c5") && <Riepilogo />}
            {/* <Riepilogo /> */}

            <div className={`section page-title-component center-on-tablet`}>
                <h1>
                    <span>Ciao {read("nome")}!</span>
                </h1>
            </div>

            <FormDatiUtenteRiconosciuto onClick={edit} />

            <InformativeC5 />

            <div className="section text-center">
                <Button id="go-to-select-state-btn" onClick={next} classList="btn-responsive always-style" loading={isCreaAppuntamentoBusy()} text={t("fissa_appuntamento")} />
            </div>

            <ErrorModal
                open={fetchError}
                text={fetchErrorMessage}
                onCloseModal={() => {
                    setFetchError(false);
                }}></ErrorModal>
        </div>
    );
};
